import {Injectable} from '@angular/core';
import { HttpParams } from '@angular/common/http';
import {PaginationFilter} from "@app/interfaces/pagination/paginationFilter";
import dayjs from 'dayjs';

@Injectable({
  providedIn: 'root'
})
export class ApiHelperService {
  static buildPaginationParams(paginationFilter: PaginationFilter): HttpParams {
    let params = new HttpParams();
    if (paginationFilter.sort) {
      params = params.append('sortBy', paginationFilter.sort.toString());

      if (paginationFilter.order) {
        params = params.append('sortOrder', paginationFilter.order.toString());
      }
    }
    params = params.append('page', paginationFilter.page || 1);
    params = params.append('perPage', paginationFilter.perPage.toString());

    if (paginationFilter.archived !== undefined) {
      params = params.append('archived', !!paginationFilter.archived);
    }

    for (const prop in paginationFilter.filter) {
      if (Array.isArray(paginationFilter.filter[prop])) {
        paginationFilter.filter[prop].forEach((item) => {
          params = params.append(prop + '[]', item);
        });
      } else if (paginationFilter.filter[prop]) {
        params = params.append(prop, ApiHelperService.serializeFilterValue(paginationFilter.filter[prop]));
      }
    }

    return params;
  }

  /**
   * Material datepicker filters (sellDateFrom/To, buyDateFrom/To, ...) hold a
   * Dayjs/Date object. HttpParams stringifies those as
   * "Mon, 01 Sep 2026 00:00:00 GMT", which the backend's whereDate() can't
   * compare against a DATE column — the filter then silently matched nothing
   * (BRIEFD-7400). Format in local time; these filters are date-only, so
   * toISOString() would shift the day for anyone east of UTC.
   */
  private static serializeFilterValue(value: any): any {
    return dayjs.isDayjs(value) || value instanceof Date ? dayjs(value).format('YYYY-MM-DD') : value;
  }
}
